import * as React from 'react';
import { CalendarIcon, CrossIcon, DropdownIcon, MHWhiteLogo } from '../../assets/Icons';
import Typograpy from '../../components/ui/Typography';
import Calendar from 'react-calendar';
import { getVendorCode } from '../../services/purposeCode';
import Button from '../../components/ui/Button';
import UploadCloud from "../../assets/svg/UploadCloud.svg";
import { Axios } from '../../services/axios';
import Toast from '../../components/ui/Toast';
import RightTick from "../../assets/svg/right-tick.svg";
import TrashBin from '../../assets/Icons/TrashBin';
import { purposeCodeList, receivingCountryData } from "../../utils";
import { Modals } from '../remittance/Modals';
import { useNavigate } from 'react-router-dom';
import ErrorField from '../../components/ui/ErrorField';
import Modal from '../../components/ui/Modal';

interface IAppProps {
    transactionMode: string
}
type ValuePiece = Date;

type Value = ValuePiece | [ValuePiece, ValuePiece];

const TravelCard: React.FC<IAppProps> = ({ transactionMode }) => {
    const [isModalOpen, setIsModalOpen] = React.useState<string>("");
    const [value, onChange] = React.useState<Value>(new Date());
    const [showCalendar, setShowCalendar] = React.useState<boolean>(false);
    const [vendorData, setVendorData] = React.useState<any>([]);
    const [selectedVendor, setSelectedVendor] = React.useState<any>({});
    const [showVendorList, setShowVendorList] = React.useState<boolean>(false);
    const [searchQuery, setSearchQuery] = React.useState(''); // State for search input
    const [remitterName, setRemitterName] = React.useState("");
    const [partnerName, setPartnerName] = React.useState("");
    const [panNumber, setPanNumber] = React.useState("");
    const [isUploaded, setIsUploaded] = React.useState(false);
    const [clientRate, setClientRate] = React.useState("");
    const [bookingRate, setBookingRate] = React.useState("");
    const [destCurrency, setDestCurrency] = React.useState<string>("USD");
    const [toastMessage, setToastMessage] = React.useState<any>();
    const [showErrorField, setShowErrorField] = React.useState<Boolean>(false);
    const [showCardErrorField, setShowCardErrorField] = React.useState<Boolean>(false);
    const [sendAmount, setSendAmount] = React.useState("");
    const [receiveAmount, setReceiveAmount] = React.useState("");
    const [panDocId, setPanDocID] = React.useState("");
    const [showPartnerList, setShowPartnerList] = React.useState(false);
    const [cardNumber, setCardNumber] = React.useState("");
    const [panError, setPanError] = React.useState("");
    const [showPanError, setShowPanError] = React.useState<boolean>(false);
    const [panFile, setPanFile] = React.useState<any>();
    const [lanNumber,setLanNumber] = React.useState<any>("")
    const [purposeCode,setPurposeCode] = React.useState<any>(purposeCodeList[1].value)
    const [showPurposeCodeList,setShowPurposeCodeList] = React.useState<boolean>(false)
    const [handlingCharges,setHandlingCharges] = React.useState<any>("")

    const navigate = useNavigate();

    const dropdownRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setShowVendorList(false); // Close the list if clicked outside
            }
        };

        document.addEventListener('mousedown', handleClickOutside); // Add event listener on mount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside); // Cleanup on unmount
        };
    }, []);


    const handleVendorCodes = () => {
        getVendorCode()
            .then((res: any) => {
                setVendorData(res?.data);
            })
            .catch((error) => {
                console.error("ERROR", error);
            });
    };

    const fileInputRef = React.useRef<HTMLInputElement | null>(null);

    const date = new Date(value?.toString());

    const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

    const data = {
        "modeOfTransaction": "TravelCard",
        "dateOfTransaction": formattedDate?.toString(),
        "vendorCode": selectedVendor?.vendorCode,
        "remitterName": remitterName,
        "panDocId": panDocId,
        "panNumber": panNumber,
        "destinationCurrency": destCurrency,
        "recipientReceive": Number(receiveAmount),
        "baseCurrency": "INR",
        "userSend": sendAmount,
        "clientRate": Number(clientRate),
        "bookingRate": Number(bookingRate),
        "travelCard": cardNumber,
        "partner": partnerName,
        "lanNumber":lanNumber,
        "transactionPurpose":purposeCode.value,
        "handlingCharges":handlingCharges
    }

    const partners = [
        "Quick Forex",
    ]

    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    const userToken = localStorage.getItem("userToken");

    const sendTravelCardDetails = async (data: any) => {
        return await Axios.post(`/remit/user/${currentUser.vendor_key}/offlineTransaction`, data, {
            headers: {
                "Access-Control-Allow-Origin": "true",
                "Content-Type": "application/json",
                Authorization: `${userToken}`,
                "X-Route-To": "remittance",
            },
        }).then((res) => {
            setToastMessage(res?.data);
            setSearchQuery("");
            setBookingRate("");
            setClientRate("");
            setPanNumber("");
            setRemitterName("");
            setReceiveAmount("")
            setSendAmount("");
            setPartnerName("");
            setCardNumber("")
            setSelectedVendor({})
            setDestCurrency("USD")
            setPanFile(null)
            handleDocRemoval()
            setPanDocID("")
            onChange(new Date())
            setLanNumber("")
            setPurposeCode(purposeCodeList[1].value)
            setHandlingCharges("")
        })
            .catch((err) => {
                setToastMessage({
                    success: "false",
                    message: err?.response?.data?.error?.type
                })
            }
            );
    };

    const uploadPanCard = async (data: any) => {
        return await Axios.post(`/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=PAN_CARD&purpose=Offline_transaction`, data, {
            headers: {
                "Access-Control-Allow-Origin": "true",
                "Content-Type": "application/json",
                Authorization: `${userToken}`,
                "X-Route-To": "remittance",
            },
        }).then((res) => {
            setPanDocID(res?.data?.leadDocId);
            setIsUploaded(true)
        }).
            catch((err) => {
                setPanError(err?.response?.data?.error?.type);
                setShowPanError(true)
            }
            );
    };

    const handleUploadButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handlePanUpload = (e: any) => {
        const fileData = e?.target?.files?.[0];
        if (fileData) {
            setPanFile(fileData);
            let data = new FormData();
            data.append("file", fileData);

            uploadPanCard(data)
                .then(() => {
                    setPanFile(null);
                    e.target.value = null;
                })
                .catch((error) => {
                    console.error("Upload failed", error);
                });
        }
    };

    const handleCloseToast = () => {
        setToastMessage(null);
    };

    const handleDocRemoval = () => {
        setIsUploaded(false)
    }

    const lanMandatoryCheck = localStorage.getItem("lanMandatory");

    return (
        <>
            {toastMessage && <Toast
                message={toastMessage?.message?.toUpperCase()}
                type={toastMessage?.success === "true" ? "success" : "failure"}
                onClose={handleCloseToast}
            />}
            <div className="flex flex-col items-center bg-primary-1050 h-full md:min-w-[379px] pt-24 pb-[92px] fixed z-50">
                <div className="flex flex-col items-center">
                    <div onClick={() => {
                        navigate("/home")
                    }} className="pb-[73px] cursor-pointer">
                        <MHWhiteLogo />
                    </div>
                    {transactionMode && (
                        <div className="-mt-10 py-4 px-6 text-white text-[20px] font-bold rounded-[100px] bg-white bg-opacity-20 min-w-[233px] flex  justify-center items-center">
                            {transactionMode === "flywire"
                                ? "Flywire Mapping"
                                : transactionMode === "offline"
                                    ? "Offline Transactions"
                                    : transactionMode === "travelCard"
                                        ? "Travel Card"
                                        : ""}
                        </div>
                    )}
                </div>
            </div>

            <div className='bg-[#f0f9ff] p-24 ml-[379px] flex flex-col h-full'>
                <div className='bg-[#fff] flex flex-col gap-6 p-8 rounded'>
                    <div className='flex items-center w-full justify-between'>
                        <div className='flex flex-col gap-3'>
                            <Typograpy tagType='p' text={"Details"} className='text-black font-bold text-3xl' />
                            <Typograpy tagType='p' text={"Please enter the amount you want to transfer"} className='text-black font-normal text-lg' />
                        </div>
                        <CrossIcon onClick={() => {
                            setIsModalOpen("cancelReasons")
                        }} className="cursor-pointer" />
                    </div>

                    <div className='flex items-center gap-6 w-full'>
                        <div className='flex flex-col gap-2 items-start w-full'>
                        <Typograpy tagType='p'>
                        Date of Transaction
                        {lanMandatoryCheck == "true" && <span style={{ color: "red" }}>*</span>}
                        </Typograpy>
                            <div className='flex flex-col items-end gap-1 w-full'>
                                <div className='flex flex-row gap-2 py-3 px-4 justify-between items-center  bg-[#fff] border border-[#efefef] rounded-lg shadow-md w-full'>
                                    <input placeholder='Choose your date' value={formattedDate?.toString()} className='flex items-center max-w-[600px] p-1 outline-none' />
                                    <CalendarIcon onClick={() => showCalendar === false ? setShowCalendar(true) : setShowCalendar(false)} className='cursor-pointer' />
                                </div>
                                {showCalendar && (
                                    <div className='absolute top-[20.5rem] mt-2 z-50'>
                                        <Calendar
                                            onClickDay={(e) => { onChange(e); setShowCalendar(false); }}
                                            value={value}
                                            selectRange={false}
                                            // minDate={new Date()}
                                            defaultActiveStartDate={new Date()}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className='flex flex-col gap-2 items-start w-full' ref={dropdownRef}>
                        <Typograpy tagType='p'>
                        Vendor Code
                        {lanMandatoryCheck == "true" && <span style={{ color: "red" }}>*</span>}
                        </Typograpy>
                            <div className='flex flex-row items-center gap-2 py-3 px-4 justify-between bg-[#fff] border border-[#efefef] rounded-lg shadow-md w-full max-w-[600px]'>
                                <input
                                    placeholder='Enter Vendor Code'
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    onClick={() => {
                                        handleVendorCodes();
                                        showVendorList === true
                                            ? setShowVendorList(false)
                                            : setShowVendorList(true);
                                    }}
                                    className='flex items-center p-1 outline-none cursor-pointer'
                                />
                                <div
                                    onClick={() => {
                                        handleVendorCodes();
                                        showVendorList === true ? setShowVendorList(false) : setShowVendorList(true);
                                    }}
                                    className='cursor-pointer'
                                >
                                    <DropdownIcon />
                                </div>
                            </div>

                            {showVendorList && (
                                <div className="w-full max-w-[570px] h-fit max-h-52 overflow-y-scroll absolute top-[20.5rem] z-50">
                                    {vendorData.length > 0 ? (
                                        vendorData
                                            .filter((option: any) => {
                                                const searchLower = searchQuery.toLowerCase();
                                                return (
                                                    option.displayName?.toLowerCase().includes(searchLower) ||
                                                    option.vendorCode?.toLowerCase().includes(searchLower)
                                                );
                                            })
                                            .map((option: any, index: any) => (
                                                <div
                                                    className="bg-grey-600 text-white p-2 cursor-pointer border-b border-white-100 hover:bg-[#fff] hover:text-black-350"
                                                    key={index}
                                                    onClick={() => {
                                                        setSelectedVendor(option); // Set selected vendor
                                                        setSearchQuery(option.displayName || option.vendorCode); // Set searchQuery to selected vendor
                                                        setShowVendorList(false); // Close the list
                                                    }}
                                                >
                                                    {option.displayName ? option.displayName : option.vendorCode}
                                                </div>
                                            ))
                                    ) : (
                                        <div className="p-2 text-white">No vendor found</div>
                                    )}
                                    {vendorData.filter((option: any) => {
                                        const searchLower = searchQuery.toLowerCase();
                                        return (
                                            option.displayName?.toLowerCase().includes(searchLower) ||
                                            option.vendorCode?.toLowerCase().includes(searchLower)
                                        );
                                    }).length === 0 && (
                                            <div className="bg-grey-600 p-4 text-white">No vendor found</div>
                                        )}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className='flex flex-col gap-2 items-start w-full'>
                    <Typograpy tagType='p'>
                        Remitter Name
                        {lanMandatoryCheck == "true" && <span style={{ color: "red" }}>*</span>}
                        </Typograpy>
                        <div className='py-3 px-4 justify-center w-full bg-[#fff] border border-[#efefef] rounded-lg shadow-md'>
                            <input
                                placeholder='Enter Remitter Name'
                                onChange={(e) => {
                                    const inputValue = e.target.value.toUpperCase();
                                    setRemitterName(inputValue)
                                }}
                                value={remitterName}
                                className='flex items-center w-full p-1 outline-none'
                                autoCapitalize={"characters"}
                            />
                        </div>
                    </div>


                    <div className='flex items-center gap-3'>
                        <div className='flex flex-col gap-2 items-start w-full'>
                        <Typograpy tagType='p'>
                        Remitter PAN
                        {lanMandatoryCheck == "true" && <span style={{ color: "red" }}>*</span>}
                        </Typograpy>
                            <div className='py-3 px-4 justify-center w-full bg-[#fff] border border-[#efefef] rounded-lg shadow-md'>
                                <input
                                    placeholder='Enter Remitter PAN'
                                    onChange={(e) => {
                                        const inputValue = e.target.value.toUpperCase();
                                        const alphanumericRegex = /^[A-Z0-9]*$/; // Only allow alphanumeric characters (uppercase)
                                        if (alphanumericRegex.test(inputValue)) {
                                            setPanNumber(inputValue); // Set PAN number only if it matches the alphanumeric pattern
                                        }
                                        if (inputValue.length === 10) {
                                            setShowErrorField(false); // If length is exactly 16, no error
                                        } else {
                                            setShowErrorField(true); // If length is not 16, show error
                                        }
                                    }}
                                    value={panNumber}
                                    className='flex items-center w-full p-1 outline-none'
                                    autoCapitalize={"characters"}
                                    maxLength={10}
                                    pattern="[A-Za-z0-9]*"
                                />
                            </div>
                            {showErrorField === true && (
                                <ErrorField errorMessage="Please Enter Correct PAN number" />
                            )}
                        </div>
                        <div className='flex flex-col gap-2 items-center w-full max-w-64'>
                            <Typograpy tagType='p' text="Remitter PAN Card (Optional)" className='self-stretch text-sm w-[232px]' />
                            <input
                                ref={fileInputRef}
                                type="file"
                                accept="image/*,application/pdf"
                                className="hidden"
                                onChange={(e) => {
                                    handlePanUpload(e);
                                }}
                            />
                            <div className='flex items-center gap-1 w-full'>
                                <Button
                                    bgColor={isUploaded ? "bg-[#E3FCEF] text-[#262A30]" : "bg-[#023496] text-white"}
                                    className={isUploaded ? "relative  hidden items-center justify-center lg:flex rounded cursor-pointer px-4 py-4" :
                                        "relative  hidden items-center justify-center lg:flex rounded cursor-pointer px-14 py-4"
                                    }
                                    onClickHandler={(event: any) => {
                                        handleUploadButtonClick();
                                        showPanError && setShowPanError(false)
                                    }}
                                >
                                    <div className="flex items-center justify-center">
                                        {isUploaded ?
                                            <>
                                                <div className={`rounded-full w-6 h-6 flex flex-col items-center justify-center`} style={{
                                                    backgroundColor: `#004004`
                                                }} >
                                                    <img src={RightTick} alt="" width={12} height={12} />
                                                </div>
                                                <span className="pl-2 font-semibold">  Uploaded successfully</span>

                                            </>
                                            :
                                            <>
                                                <img src={UploadCloud} />
                                                <span className="pl-2 font-semibold">Upload photo</span>
                                            </>
                                        }
                                    </div>
                                </Button>
                                {isUploaded &&
                                    <div className='cursor-pointer' onClick={() => handleDocRemoval()}>
                                        <TrashBin fillColor='#DA0507' />
                                    </div>
                                }
                            </div>
                            {showPanError && <ErrorField errorMessage={panError} />}
                        </div>
                    </div>

                    <div className='flex flex-col gap-2 items-start w-full'>
                    <Typograpy tagType="p">
                        Enter LAN No (if any)
                        {lanMandatoryCheck == "true" && <span style={{ color: "red" }}>*</span>} 
                    </Typograpy>
                            <div className='py-3 px-4 justify-center w-full bg-[#fff] border border-[#efefef] rounded-lg shadow-md'>
                                <input
                                    placeholder='Enter LAN No (if any)'
                                    onChange={(e) => {
                                        const inputValue = e.target.value.toUpperCase();
                                        setLanNumber(inputValue)
                                    }}
                                    value={lanNumber}
                                    className='flex items-center w-full p-1 outline-none'
                                    autoCapitalize={"characters"}
                                    maxLength={12}
                                />
                            </div>
                        </div>
                 

                    <div className='flex items-center gap-3 w-full'>
                        <div className='flex flex-col gap-2 items-start w-full'>
                        <Typograpy tagType='p'>
                        You Send
                        {lanMandatoryCheck == "true" && <span style={{ color: "red" }}>*</span>}
                        </Typograpy>
                            <div className='flex flex-row py-3 px-4 justify-between  bg-[#fff] border border-[#efefef] rounded-lg shadow-md w-full'>
                                <input type='number' placeholder='Enter amount' value={sendAmount} onChange={(e) => setSendAmount(e?.target?.value)} className='flex items-center p-1 outline-none border-r-[#DFDFDF] w-full' />
                                <div
                                    className="flex space-x-3 rounded-md cursor-pointer border-l border-[#dfdfdf] mr-3"
                                >
                                    <img
                                        src={`/images/png/INR.png`}
                                        alt="receiving-country-image"
                                        className="rounded-[200px] w-7 h-7 ml-3"
                                    />
                                    <span className="bg-white text-[19px] space-x-2 flex items-center">
                                        <span className="">INR</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className='flex flex-col gap-2 items-start w-full'>
                        <Typograpy tagType='p'>
                        They Receive
                        {lanMandatoryCheck == "true" && <span style={{ color: "red" }}>*</span>}
                        </Typograpy>
                            <div className='flex flex-row py-3 px-4 justify-between  bg-[#fff] border border-[#efefef] rounded-lg shadow-md w-full'>
                                <input type='number' placeholder='Enter Receiving amount' value={receiveAmount} onChange={(e) => setReceiveAmount(e?.target?.value)} className='flex items-center p-1 w-full outline-none border-r-[#DFDFDF]' />
                                <div
                                    onClick={() => setIsModalOpen("recieve")}
                                    className="flex space-x-3 rounded-md cursor-pointer border-l border-[#dfdfdf] mr-6"
                                >
                                    <img
                                        src={`/images/png/${destCurrency}.png`}
                                        alt="receiving-country-image"
                                        className="rounded-[200px] w-7 h-7 ml-3"
                                    />
                                    <span className="bg-white text-[19px] space-x-2 flex items-center">
                                        <span className="">{destCurrency}</span>
                                        <DropdownIcon />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='flex flex-col gap-2 items-start w-full'>
                    <Typograpy tagType="p">
                        Purpose Code
                        {lanMandatoryCheck == "true" && <span style={{ color: "red" }}>*</span>} 
                    </Typograpy>
                        <div className='flex items-center py-3 px-4 justify-between w-full bg-[#fff] border border-[#efefef] rounded-lg shadow-md'>
                            <input
                               readOnly
                                defaultValue={purposeCodeList[1].value}
                                value={purposeCode.value}
                                className='flex items-center w-full max-w-[1255px] p-1 outline-none cursor-pointer'
                                autoCapitalize={"characters"}
                                onClick={() => {
                                    showPurposeCodeList === true ? setShowPurposeCodeList(false) : setShowPurposeCodeList(true)
                                }}
                            />
                            <div onClick={() => showPurposeCodeList === true ? setShowPurposeCodeList(false) : setShowPurposeCodeList(true)} className='cursor-pointer'>
                                <DropdownIcon />
                            </div>
                        </div>
                        {
                            showPurposeCodeList && (
                                <div className="w-full max-w-[1280px] h-fit max-h-52 overflow-y-scroll absolute top-[56rem]">
                                    {
                                        purposeCodeList.map((purpose: any, index: any) => (
                                            <div
                                                className="bg-grey-600 text-white p-2 cursor-pointer border-b border-white-100 hover:bg-[#fff] hover:text-black-350"
                                                key={index}
                                                onClick={() => {
                                                    setPurposeCode(purpose); 
                                                    setShowPurposeCodeList(false); 
                                                }}
                                            >
                                                {purpose.value}
                                            </div>
                                        ))
                                    }
                                </div>
                            )
                        }
                    </div>

                    <div className='flex items-center gap-3'>
                        <div className='flex flex-col gap-2 items-start w-full'>
                        <Typograpy tagType='p'>
                        Client Rate
                        {lanMandatoryCheck == "true" && <span style={{ color: "red" }}>*</span>}
                        </Typograpy>
                            <div className='py-3 px-4 justify-center w-full bg-[#fff] border border-[#efefef] rounded-lg shadow-md'>
                                <input
                                    placeholder='Enter Client Rate'
                                    onChange={(e) => {
                                        const inputValue = e.target.value.toUpperCase();
                                        setClientRate(inputValue)
                                    }}
                                    value={clientRate}
                                    className='flex items-center w-full p-1 outline-none'
                                    type='number'
                                />
                            </div>
                        </div>
                        <div className='flex flex-col gap-2 items-start w-full'>
                        <Typograpy tagType='p'>
                        Booking Rate
                        {lanMandatoryCheck == "true" && <span style={{ color: "red" }}>*</span>}
                        </Typograpy>
                            <div className='py-3 px-4 justify-center w-full bg-[#fff] border border-[#efefef] rounded-lg shadow-md'>
                                <input
                                    placeholder='Enter Booking Rate'
                                    onChange={(e) => {
                                        const inputValue = e.target.value.toUpperCase();
                                        setBookingRate(inputValue)
                                    }}
                                    value={bookingRate}
                                    className='flex items-center w-full p-1 outline-none'
                                    type='number'
                                />
                            </div>
                        </div>
                    </div>

                    <div className='flex flex-col gap-2 items-start w-full'>
                    <Typograpy tagType="p">
                        Handling Charges
                        {lanMandatoryCheck == "true" && <span style={{ color: "red" }}>*</span>} 
                    </Typograpy>
                            <div className='py-3 px-4 justify-center w-full bg-[#fff] border border-[#efefef] rounded-lg shadow-md'>
                                <input
                                    placeholder='Enter Handling Charges'
                                    onChange={(e) => {
                                        const inputValue = e.target.value.toUpperCase();
                                        setHandlingCharges(inputValue)
                                    }}
                                    value={handlingCharges}
                                    className='flex items-center w-full p-1 outline-none'
                                    type='number'
                                />
                            </div>
                        </div>

                    <div className='flex items-center gap-3'>
                        <div className='flex flex-col gap-2 items-start w-full'>
                        <Typograpy tagType='p'>
                        Card Number
                        {lanMandatoryCheck == "true" && <span style={{ color: "red" }}>*</span>}
                        </Typograpy>
                            <div className='py-3 px-4 justify-center w-full bg-[#fff] border border-[#efefef] rounded-lg shadow-md'>
                                <input
                                    pattern="^[a-zA-Z0-9]+$"
                                    placeholder='Enter your Card Number'
                                    onChange={(e) => {
                                        const inputValue = e.target.value.toUpperCase();
                                        const alphanumericValue = inputValue.replace(
                                            /[^a-zA-Z0-9]/g,
                                            ""
                                        ); // Remove non-alphanumeric characters
                                        setCardNumber(alphanumericValue); // Update state with filtered value
                                        if (alphanumericValue.length === 16) {
                                            setShowCardErrorField(false); // If length is exactly 16, no error
                                        } else {
                                            setShowCardErrorField(true); // If length is not 16, show error
                                        }
                                    }}
                                    value={cardNumber}
                                    className='flex items-center w-full p-1 outline-none'
                                    autoCapitalize={"characters"}
                                    maxLength={16}
                                />
                            </div>
                            {showCardErrorField === true && (
                                <ErrorField errorMessage="Please Enter Correct Card number" />
                            )}
                        </div>

                        <div className='flex flex-col gap-2 items-start w-full'>
                        <Typograpy tagType='p'>
                        Partner Name
                        {lanMandatoryCheck == "true" && <span style={{ color: "red" }}>*</span>}
                        </Typograpy>
                            <div className='flex items-center py-3 px-4 justify-between w-full bg-[#fff] border border-[#efefef] rounded-lg shadow-md'>
                                <input
                                    placeholder='Enter your Partner Name'
                                    readOnly
                                    value={partnerName}
                                    className='flex items-center w-full p-1 outline-none cursor-pointer'
                                    autoCapitalize={"characters"}
                                    onClick={() => {
                                        showPartnerList === true ? setShowPartnerList(false) : setShowPartnerList(true)
                                    }}
                                />
                                <div onClick={() => showPartnerList === true ? setShowPartnerList(false) : setShowPartnerList(true)} className='cursor-pointer'>
                                    <DropdownIcon />
                                </div>
                            </div>
                            {
                                showPartnerList && (
                                    <div className="w-full max-w-[395px] h-fit max-h-52 overflow-y-scroll absolute top-[77.5rem]">
                                        {
                                            partners.map((partner: any, index: any) => (
                                                <div
                                                    className="bg-grey-600 text-white p-2 cursor-pointer border-b border-white-100 hover:bg-[#fff] hover:text-black-350"
                                                    key={index}
                                                    onClick={() => {
                                                        setPartnerName(partner); 
                                                        setShowPartnerList(false); 
                                                    }}
                                                >
                                                    {partner}
                                                </div>
                                            ))
                                        }
                                    </div>
                                )
                            }
                        </div>
                    </div>

                    <div className='flex flex-row !items-end justify-end'>
                        <Button bgColor='bg-[#023496]' className='rounded-lg py-4 px-12 flex justify-center items-center text-white text-lg font-medium' onClickHandler={async (e: any) => {
                            try {
                                const response = await sendTravelCardDetails(data);
                            } catch (error) {
                                console.error('Error:', error);
                            }
                        }}
                            disabled={showErrorField || sendAmount?.length < 1 || receiveAmount?.length < 1 || searchQuery === "" || remitterName === "" || panNumber === "" || clientRate === "" || bookingRate === "" || partnerName === "" || cardNumber === ""}
                        >
                            Submit
                        </Button>
                    </div>
                </div>
            </div>
            <Modals
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                destCurrency={destCurrency}
                setDestCurrency={setDestCurrency}
                receivingCountryModalData={receivingCountryData}
            />
            <Modal
                header="Cancel Transaction"
                headerClass={"text-white"}
                modalClass="!p-0 rounded lg:overflow-hidden overflow-y-scroll max-h-[90%] lg:max-h-full"
                visible={isModalOpen === "cancelReasons"}
                closeHandler={() => setIsModalOpen("")}
                closable={false}
            >
                <div className="flex flex-col items-center px-5 py-10 space-y-6">
                    <span className="font-ssp text-[18px] ">
                        Are you sure you want to cancel the transaction?
                    </span>
                    <div className="flex justify-center w-full space-x-5">
                        <button
                            onClick={() => navigate("/home")}
                            className="w-1/4 px-6 py-2 font-bold text-white transition-all rounded-full bg-primary hover:bg-primary-650 hover:scale-105 font-ssp"
                        >
                            Yes
                        </button>
                        <button
                            onClick={() => setIsModalOpen("")}
                            className="w-1/4 px-6 py-2 font-bold text-white transition-all rounded-full bg-primary hover:bg-primary-650 hover:scale-105 font-ssp"
                        >
                            No
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default TravelCard;
